import { useState } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Services from "../components/Services";
import Founder from "../components/Founder";
import Proof from "../components/Proof";
import Footer from "../components/Footer";
import BookingModal from "../components/BookingModal";

export default function LandingPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);

  return (
    <main className="relative bg-void text-foreground" data-testid="landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav onBook={openBooking} />
      <Hero onBook={openBooking} />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <Founder />
      <Proof onBook={openBooking} />
      <Footer onBook={openBooking} />
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} />
    </main>
  );
}
